import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CirclesSection from "./components/CirclesSection";
import WorksSection from "./components/WorksSection";
import PostsSection from "./components/PostsSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  useSeo(
    "178漫画网 - 漫友同好交流聚集地，按作品和题材划分漫圈",
    "178漫画网是漫友同好聚集地，按作品和题材划分漫圈，随时找到同好交流剧情、分享心得。每部漫画下方都有讨论区，热门作品更有专属圈子。追漫有人陪聊。",
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <Hero />
        <CirclesSection />
        <WorksSection />
        <PostsSection />
        <FaqSection />

        {/* CTA */}
        <section className="relative overflow-hidden bg-primary-600 py-16 md:py-20">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20cheerful%20young%20comic%20fans%20high%20fiving%20under%20floating%20speech%20bubbles%20and%20sparkles%2C%20warm%20coral%20and%20cream%20palette%2C%20celebration%20energy%2C%20manga%20style%20flat%20illustration&width=1600&height=700&seq=cta-community&orientation=landscape"
              alt=""
              className="h-full w-full object-cover object-center"
            />
          </div>
          <div className="relative z-10 mx-auto max-w-3xl px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl text-background-50">
              找到你的同好，追漫有人陪聊
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-primary-100">
              无论你爱热血、悬疑还是恋爱番，在178漫画网都能找到聊得来的漫友。现在就进圈，从一句话开始。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/circles"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 hover:bg-background-100 transition-colors"
              >
                <i className="ri-user-heart-line text-lg" /> 加入漫圈
              </Link>
              <Link
                to="/works"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 hover:bg-background-50/10 transition-colors"
              >
                浏览热门作品
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}